export function poucesConvertor(info){
 return info.replace("p","'").replace("pp",'"')
}